/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodInventoryInvestigation from './blood-inventory-investigation';
import BloodInventoryInvestigationDetail from './blood-inventory-investigation-detail';
import BloodInventoryInvestigationUpdate from './blood-inventory-investigation-update';
import BloodInventoryInvestigationDeleteDialog from './blood-inventory-investigation-delete-dialog';

const BloodInventoryInvestigationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodInventoryInvestigation />} />
    <Route path="new" element={<BloodInventoryInvestigationUpdate />} />
    <Route path=":id">
      <Route index element={<BloodInventoryInvestigationDetail />} />
      <Route path="edit" element={<BloodInventoryInvestigationUpdate />} />
      <Route path="delete" element={<BloodInventoryInvestigationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodInventoryInvestigationRoutes;
